import BaseResource from './index'
import { env } from '../config'
import { Client } from './index'

export default class PageResource extends BaseResource {
    static endpoint = '/pages'
    static client = new Client(env.API_BASE_URL)

    async getContent() {
        const wrapped = this.wrap('/content')
        const result = await wrapped.get()
        return result.data.html
    }

    toString() {
        return this.attributes.name
    }
}
